module.exports = __webpack_public_path__ + "static/media/unknown.20979fbc.svg";